export default __webpack_public_path__ + "static/media/A5.0637760c.jpg";